import { useEffect, useState } from "react";
import { Tab } from ".";
import VirtualTable from "../../../components/custom/VirtualTable";
import apiClient from "../../../apiClient";

export default function Log ({
    activeTab
}: {
    activeTab: Tab
}) {

    const [data, setData] = useState([]);

    useEffect(() => {   
        const getData = async () => {
            try {
                const res = await apiClient.get('/message-groups/logs');
                setData(res.data);
            } catch (err) {
                alert(err);
            }
        }
        if (activeTab === 'LOG') {
            getData();
        }
    }, [activeTab]);

    return (
        <VirtualTable 
            data={data}
            mapping={[{
                name: 'Group',
                value: 'groupName'
            }, {
                name: 'Message',
                value: 'message'
            }, {
                name: 'To',
                value: 'sentTo'
            }]}
        />
    );
}